import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center' }}>
      <h1 style={{ fontSize: '48px', marginBottom: '16px' }}>404 - Страница не найдена</h1>
      <p style={{ fontSize: '18px', marginBottom: '32px' }}>Извините, запрашиваемая страница не существует.</p>
      <Link to="/" className="button" style={{ padding: '12px 24px', fontSize: '16px', textDecoration: 'none', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}>Вернуться на главную</Link>
      v11072023-4
    </div>
  );
};

export default NotFound;